
export default {
    worklist() {
        return window.restApi.get('v2/visit/list');
    },
    getDetail(id) {
        return window.restApi.get('v2/patient/get/' + id);
    },
    listPatient(model) {
        return window.restApi.get('v2/patient/list', {params: model});
    },
    savePatient(model, config) {
        if (model.id) {
            return window.restApi.post('v2/patient/update', model, config);
        } else {
            return window.restApi.post('v2/patient/save', model, config);
        }
    },
}
